import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className={className}
        >
          <path d="M27.913 6.525l-6.25-6.25A.938.938 0 0021 0H6.625a2.816 2.816 0 00-2.813 2.813v26.375A2.816 2.816 0 006.626 32h18.75a2.816 2.816 0 002.813-2.813v-22a.938.938 0 00-.275-.662zM21.937 3.2l3.05 3.049h-3.05V3.2zm3.438 26.924H6.625a.939.939 0 01-.938-.938V2.813c0-.516.421-.937.938-.937h13.438v5.313c0 .517.42.937.937.937h5.313v21.063c0 .516-.421.937-.938.937z"></path>
          <path d="M20.375 20h-5.313v-5.313a.938.938 0 00-.937-.937c-3.963 0-7.188 3.224-7.188 7.188 0 3.963 3.225 7.187 7.188 7.187 3.963 0 7.188-3.224 7.188-7.188a.938.938 0 00-.938-.937zm-6.25 6.25a5.319 5.319 0 01-5.313-5.313 5.322 5.322 0 014.376-5.23v5.23c0 .518.42.938.937.938h5.23a5.322 5.322 0 01-5.23 4.375z"></path>
          <path d="M17.875 10a.937.937 0 00-.938.938v6.25c0 .517.42.937.938.937h6.25c.518 0 .938-.42.938-.938 0-3.963-3.225-7.187-7.188-7.187zm.938 6.25v-4.292a5.328 5.328 0 014.292 4.292h-4.293z"></path>
        </svg>
    );
};